import { render, staticRenderFns } from "./ManagerCandidateItemDocuments.vue?vue&type=template&id=395d0bd1&scoped=true"
import script from "./ManagerCandidateItemDocuments.vue?vue&type=script&lang=js"
export * from "./ManagerCandidateItemDocuments.vue?vue&type=script&lang=js"
import style0 from "./ManagerCandidateItemDocuments.vue?vue&type=style&index=0&id=395d0bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d0bd1",
  null
  
)

export default component.exports